import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer.component';
import { LinkComponent as MobileLinkComponent } from '../../ui-components/navigation/mobile-navigation/link/link.component';
import { UrlConfig } from './../../../config/url-config';
import { MatIconModule } from '@angular/material/icon';
import { NavigationModule } from '../../ui-components/navigation/navigation.module';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    NavigationModule,
  ],
  declarations: [
    FooterComponent,
    // MobileLinkComponent
  ],
  providers: [
    UrlConfig
  ],
  exports: [
    FooterComponent,
  ]
})
export class FooterModule {}
